// JavaScript Document


function initDynamicModal() {

    const documentBody = document.querySelector('body');

    const modalTriggers = document.querySelectorAll('.open-modal');

    const pageId = document.querySelector('body').dataset.pageId;


    let dynamicModal;
    let bsDynamicModal;


    modalTriggers.forEach(function(modalTrigger){


        modalTrigger.addEventListener('click', function(e){
           
            e.preventDefault();
            const formType = this.dataset.type;
            loadModal(formType,pageId);
        })
    });


    function loadModal(type,pageId = false) {

        loading.show(documentBody,'pos','fixed');

        var request = new XMLHttpRequest();
        //cursor.setAjaxState();
        request.open('POST', ajaxurl, true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
        request.onload = function () {
            if (this.status >= 200 && this.status < 400) {
                // If successful
                openModal(this.responseText, type);
            } else {
                // If fail
                openModal('<h3>Es ist ein Fehler aufgetreten</h3>');
                //console.log(this.response);
            }
        };
        request.onerror = function() {
            openModal('<h3>Es ist ein Fehler aufgetreten</h3>');
        };
        request.send('action=load_dynamic_modal&type=' + type + '&page_id=' + pageId);
    }

    function openModal(html, type) {
        loading.hide();
        let modalPosition = "";
        let modalSize = "";

        if (type === 'search') {

            modalPosition = 'modal-dialog-centered';
            modalSize = "modal-lg";

       

        } else {

            modalSize = "modal-xl";
        }

        /* } else if (type === 'pano') {

             modalSize = "modal-fullscreen";
        */

        


        let     modalHTML = '<div class="modal fade" id="dynamicModal" aria-hidden="true" tabindex="-1">';
                modalHTML += '<div class="modal-dialog  '+modalSize+' '+modalPosition+'">';
                modalHTML += '<div class="modal-content bg-primary text-white">';
                if (type != 'search') {
                    modalHTML += '      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>';
                }
                modalHTML += '      <div class="modal-inner">';
                modalHTML +=  html 
                modalHTML += '      </div>';
                modalHTML += '</div>';
                modalHTML += '</div>';
                modalHTML += '</div>';

        appendHtml(document.body, modalHTML);

        dynamicModal = document.getElementById('dynamicModal');

        bsDynamicModal = new bootstrap.Modal('#dynamicModal', {
            keyboard: false
        });
        

        bsDynamicModal.show();

        dynamicModal.addEventListener('shown.bs.modal', event => {

            init();
            _scrollSmoother.pause();

        });

        dynamicModal.addEventListener('hidden.bs.modal', event => {
            dynamicModal.remove();
            _scrollSmoother.unpause();
        });




    }

    function init() {

            const standortSelects = dynamicModal.querySelectorAll('.standort-select');

            standortSelects.forEach(function(standortSelecter){

                initStadortSelect(standortSelecter);

            });
            
            if (dynamicModal.querySelector('.but-form')) {
                initFormButs(dynamicModal);
            }

            if (dynamicModal.querySelector('.nav-link.stellen-item')) {
                initStellenItems(dynamicModal);
            }

            

            

    }

    function closeModal() {
        if (bsDynamicModal) {
            bsDynamicModal.hide();
        }

    }



    return {
        loadModal: loadModal,
        hide: closeModal,
    };


}
